import { useEffect, useRef, useState } from 'react';

// /getLogo can fail transiently (cold starts, DB connection errors), so retry
// a couple of times before falling back to the default FNI branding.
export const RETRY_DELAYS_MS = [500, 1000];

const LogoImage = ({ code, fallbackSrc, ...imgProps }) => {
    const [attempt, setAttempt] = useState(0);
    const [failed, setFailed] = useState(false);
    const retryTimer = useRef(null);

    useEffect(() => () => clearTimeout(retryTimer.current), []);

    const handleError = () => {
        if (attempt < RETRY_DELAYS_MS.length) {
            retryTimer.current = setTimeout(() => setAttempt(attempt + 1), RETRY_DELAYS_MS[attempt]);
        } else {
            setFailed(true);
        }
    };

    const logoSrc = `/getLogo?code=${encodeURIComponent(code)}${attempt ? `&retry=${attempt}` : ''}`;

    return (
        <img
            {...imgProps}
            src={failed ? fallbackSrc : logoSrc}
            onError={failed ? undefined : handleError}
        />
    );
};

// With no tenant code there is nothing to fetch, so show the default branding
// directly. Callers must pass the tenant code as soon as it is knowable (e.g. from
// the URL) or the fallback will flash before the tenant logo. Keyed on code so a
// tenant change starts with fresh retry state.
const TenantLogoImage = ({ code, fallbackSrc, ...props }) => (
    code
        ? <LogoImage key={code} code={code} fallbackSrc={fallbackSrc} {...props} />
        : <img {...props} src={fallbackSrc} />
);

export default TenantLogoImage;
